module.exports = __webpack_public_path__ + "img/celka_hydro2.069f8b21.webp";